import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ReviewCarouselWidget extends Component {
    constructor (props) {
        super(props);

        this.state = {};
    }

    componentDidMount () {
        const widgetScript = document.createElement('script');
        document.body.appendChild(widgetScript);

        /*eslint-disable*/
        let rcrcScript = `
        (function(w, d, s, o, f, js, fjs) {
        w['RacecheckReviewCarousel']=o;w[o] = w[o] || function (){(w[o].q = w[o].q || []).push(arguments)};
        js = d.createElement(s); fjs = d.getElementsByTagName(s)[0];
        js.id = o;js.src = f;js.async = 1;fjs.parentNode.insertBefore(js, fjs);
        }(window, document, 'script', 'rcrc', '${process.env.REACT_APP_API_URL}/static/js/review_carousel.js'));
        rcrc('init', {carousel: '${this.props.widgetId}', tracking: false, demo: true});`;
        {/* eslint-enable*/}
        widgetScript.type = 'text/javascript';
        widgetScript.innerHTML = rcrcScript;
        this.checkForWidgetLoad();
    }

    componentWillUnmount () {
        window.rcrc.widgetCleanup();
    }

    async checkForWidgetLoad () {
        /*eslint-disable*/
        while (!document.querySelector('#racecheck-review-carousel-iframe')) {
            await new Promise(r => setTimeout(r, 100));
        }
        try {
            document.getElementById('racecheck-review-carousel').appendChild(document.getElementById('racecheck-review-carousel-iframe'));
            document.getElementById('racecheck-review-carousel-iframe').style.display = 'block';
        }
        catch {}
        /* eslint-enable*/
    }

    render () {
        return <div id="racecheck-review-carousel" />;
    }
}

ReviewCarouselWidget.propTypes = {
    widgetId: PropTypes.number.isRequired
};

export default ReviewCarouselWidget;
